import api from './api';

const uploadFileToS3 = async (file, { bucketName, region, dirName } = {}) => {
    const { url, fields, key, location } = await api.service.getApi().post('/uploads/presign', {
        bucketName,
        region,
        dirName,
        fileName: file.name,
        contentType: file.type || 'application/octet-stream'
    });

    const formData = new FormData();
    Object.entries(fields).forEach(([field, value]) => formData.append(field, value));
    formData.append('file', file);

    const response = await fetch(url, {
        method: 'POST',
        body: formData
    });

    if (!response.ok) {
        throw new Error(`S3 upload failed with status ${response.status}`);
    }

    return {
        key,
        location,
        result: {
            ok: true,
            status: response.status
        }
    };
};

export default { uploadFileToS3 };
